<template>
<div>
  <bsp-table
    :data.sync="list"
    ref="accountTable"
    :ciic-data-filter.sync="listQuery"
    @ciic-data-refresh="_getEmpWagesDetailList"
    :showPagination="listQuery.page"
    style="width: 100%"
    >
    <bsp-table-column
      field="empId"
      title="员工编号"
      filter-type="input"
      width="10%">
      <template slot-scope="scope">{{ scope.row.empId }}</template>
    </bsp-table-column>
    <bsp-table-column
      field="accountName"
      title="员工姓名"
      filter-type="input"
      width="10%">
      <template slot-scope="scope">{{ scope.row.accountName }}</template>
    </bsp-table-column>
     <bsp-table-column
       field="idCardType"
       filter-type="select"
       title="证件类型"
      width="10%">
       <template slot-scope="scope">{{ scope.row.idCardType }}</template>
    </bsp-table-column>
    <bsp-table-column
      field="idCard"
      label="证件号"
      sortable
      filter-type="input"
      width="10%">
      <template slot-scope="scope">{{ scope.row.idCard }}</template>
     </bsp-table-column>
    <bsp-table-column
      field="accountFullName"
      title="开户银行全称"
      filter-type="input"
      width="10%">
      <template slot-scope="scope">{{ scope.row.accountFullName }}</template>
    </bsp-table-column>
    <bsp-table-column
      field="accountNum"
      title="开户账号"
      filter-type="input"
      width="10%">
      <template slot-scope="scope">{{ scope.row.accountNum }}</template>
    </bsp-table-column>
    <bsp-table-column
      field="accountName"
      title="开户名"
      filter-type="input"
      width="10%">
      <template slot-scope="scope">{{ scope.row.accountName }}</template>
    </bsp-table-column>
    <bsp-table-column
      field="taxType"
      filter-type="select"
      title="计税类型"
      width="10%">
      <template slot-scope="scope">{{ scope.row.taxType  }}</template>
    </bsp-table-column>

  </bsp-table>


</div>

</template>

<script>
  import bspTable from "@/components/bsp/bsp-table/bsp-table";
  import bspTableColumn from "@/components/bsp/bsp-table-column/bsp-table-column";
  import {getEmpWagesDetailList} from "@/api/tax/tax";
  import {getServerDictsMap, getServerDictsList, getDictsListBySetId} from '@/api/sys/code'
  import { mapGetters } from 'vuex';
    export default {
        name: "empWagesDetailList",
      components: { bspTableColumn, bspTable},
      created(){
          this._getEmpWagesDetailList();

      },
      mounted() {

      },
      computed: {
        ...mapGetters([
          'dicts',
          'pms'
        ]),
      },
      data(){
          return{
            list:[],
            // idCardTypeList: [],
            // taxTypeList:[],
            // serverDictsMap: null,
            // serverDictsList:null,
            listQuery:{
              limit: 20,
              page: 1,
              total: 0
            }
          }
      },
      methods:{

        _getEmpWagesDetailList(){
          getEmpWagesDetailList(this.listQuery).then(res => {
            console.log(res);
           this.listQuery.total = res.data.total
            this.list = res.data.records
       } ).catch((error) => {
        console.log("错误信息"+error)
      })
        },
        // getServerDictsMap() {
        //   getServerDictsMap().then(res => {
        //     console.log("排除后的项")
        //     console.log(res)
        //     this.serverDictsMap = res.data.data
        //   })
        // },
        // getServerDictsList() {
        //   getServerDictsList().then(res => {
        //     console.log("排除后的代码集")
        //     console.log(res)
        //     this.serverDictsList = res.data.data;
        //     this.cityList = this.serverDictsList[1026]
        //   })
        // },
        //复选框单选事件
        selectChange({ checked, row }){
          console.log(checked, row)
        },
        //复选框全选事件
        selectAll({checked, selection}){
          console.log(checked, selection)
        },
      }

    }

</script>

<style scoped>

</style>
